import type { LoginResponse } from '@shared/api';

const USERNAME = 'ica-username';
export const AUTH = 'ica_state';

export class LocalStorageUtils {
  static getUsername = () => localStorage.getItem(USERNAME) ?? '';
  static setUsername = (userName: string) => localStorage.setItem(USERNAME, userName);
  static removeUsername = () => localStorage.removeItem(USERNAME);

  static getAuth = (): LoginResponse | null => {
    const auth = localStorage.getItem(AUTH);
    return auth ? JSON.parse(auth) : null;
  };
  static setAuth = (data: LoginResponse) => localStorage.setItem(AUTH, JSON.stringify(data));
  static removeAuth = () => localStorage.removeItem(AUTH);
}
